<template>
 <div class="custom-dialog" :style="{left: $vuetify.application.left+'px'}">
    <div class="custom-dialog-container">
      <div class="custom-dialog-closer"></div>
        <v-container>
          <pop-up-layout :saving="saving" :title="titulo" :description="pregunta">
            <v-layout column justify-center align-center>
              <v-img 
                style="margin-bottom: 30px; width:180px;" 
                :src="require('@/assets/images/WARNING_GRIS.png')"
              />
              <o-description-title v-if="consecuencia">
                {{consecuencia}}
              </o-description-title>
              <o-description-title v-if="alerta">
                {{alerta}}
              </o-description-title>
              <v-checkbox
              v-if="mostrarCheck"
                  color="primary"
                  class="grey--text pl-2 mt-0" 
                  v-model="chequeado" 
                  :label="textoCheck"
                >
              </v-checkbox>
            </v-layout>
            <v-layout wrap justify-center align-center slot="acciones">
              <v-btn 
                color="primary" 
                @click="$emit('aceptar',false); "
                :disabled="saving || loading"
              >
                {{cancelar}}
              </v-btn>
              <v-btn 
                color="primary" 
                @click="$emit('aceptar',true)"
                :disabled="saving || loading"
                :loading="saving"
              >
                {{descartar}}
              </v-btn>
            </v-layout>
          </pop-up-layout>
        </v-container>
      </div>
  </div>
</template>

<script>
  export default {
    props: {
      titulo: {
        type: String,
        default () {
          return this.$t('general.popUpSeguro.titulo')
        }
      },
      pregunta: {
        type: String,
        default () {
          return this.$t('general.popUpSeguro.pregunta')
        }
      },
      textoCheck: {
        type: String,
        default () {
          return ''
        }
      },
      mostrarCheck: {
        type: Boolean,
        default: false
      },
      valorCheck: {
        type: Boolean,
        default: false
      },
      consecuencia: {
        type: String,
        default: ''
      },
      alerta: {
        type: String,
        default () {
          return this.$t('general.popUpSeguro.alerta')
        }
      },
      descartar: {
        type: String,
        default () {
          return this.$t('general.popUpSeguro.descartar')
        }
      },
      cancelar: {
        type: String,
        default () {
          return this.$t('general.popUpSeguro.cancelar')
        }
      },
      saving: {
        type: Boolean,
        default: false
      },
      loading: {
        type: Boolean,
        default: false
      },
      disabled: {
        type: Boolean,
        default: false
      }
    },
    data () {
    return {
      chequeado: false
    }
  },
    watch: {
      chequeado: {
        handler () {
          this.$emit('update:valorCheck', this.chequeado)
        }
      }
    }
  }
</script>

<style lang="stylus" scoped>
  .custom-dialog
    position fixed
    top 0
    bottom 0
    right 0
    left 0
    z-index 6
    overflow-y scroll
    transition-property: transform, width, -webkit-transform
    transition: 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  .custom-dialog-container
    position relative
    min-height 100%
    width 100%
    display flex
    align-content center
  .custom-dialog-closer
    position absolute
    top 0
    bottom 0
    left 0
    right 0
    background-color rgba(0,0,0,.8)
    &:hover
      cursor pointer
</style>




// WEBPACK FOOTER //
// src/components/generic/PopUpSeguro.vue